import { Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ExportTriggerQuery, ExportTriggerService } from '@y42/data-export';
import { AbstractFeatureAggregationService, AbstractFeatureChildService } from '@y42/feature';
import { Y42RouterService } from '@y42/feature/routing';
import { AbstractFeatureChildQueryEntity } from '@y42/feature';
import { IntegrationTableQuery, IntegrationTableService } from '@y42/integration';
import { Y42FeatureType } from '@y42/json-schema';
import { SqlModelingTableQuery, SqlModelingTableService } from '@y42/sql-model';
import { UiModelingTableQuery, UiModelingTableService } from '@y42/ui-model';
import { VisualizationTabQuery, VisualizationTabService } from '@y42/visualization/tab';

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class Y42FeatureChildAggregationService extends AbstractFeatureAggregationService<
  AbstractFeatureChildService,
  AbstractFeatureChildQueryEntity
> {
  constructor(
    protected readonly routerService: Y42RouterService,

    private readonly visualizationTabService: VisualizationTabService,
    private readonly visualizationTabQuery: VisualizationTabQuery,

    private readonly integrationTableService: IntegrationTableService,
    private readonly integrationTableQuery: IntegrationTableQuery,

    private readonly uiModelingTableService: UiModelingTableService,
    private readonly uiModelingTableQuery: UiModelingTableQuery,

    private readonly sqlModelingTableService: SqlModelingTableService,
    private readonly sqlModelingTableQuery: SqlModelingTableQuery,

    private readonly exportTriggerService: ExportTriggerService,
    private readonly exportTriggerQuery: ExportTriggerQuery,
  ) {
    super(routerService);
  }

  readonly featureTypeToServiceDefinition = {
    [Y42FeatureType.Integration]: {
      service: this.integrationTableService,
      query: this.integrationTableQuery,
    },
    [Y42FeatureType.UiModel]: {
      service: this.uiModelingTableService,
      query: this.uiModelingTableQuery,
    },
    [Y42FeatureType.SqlModel]: {
      service: this.sqlModelingTableService,
      query: this.sqlModelingTableQuery,
    },
    [Y42FeatureType.Orchestration]: null,
    [Y42FeatureType.VisualizationDashboard]: {
      service: this.visualizationTabService,
      query: this.visualizationTabQuery,
    },
    [Y42FeatureType.VisualizationWidget]: null,
    [Y42FeatureType.VisualizationTheme]: null,
    [Y42FeatureType.VisualizationFilter]: null,
    [Y42FeatureType.Export]: {
      service: this.exportTriggerService,
      query: this.exportTriggerQuery,
    },
    [Y42FeatureType.Lineage]: null,
    [Y42FeatureType.StatusAlert]: null,
    [Y42FeatureType.Catalog]: null,
  } as const;
}
